import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Route } from 'react-router';
import AdminUsersList from './adminUsersList';
import AdminUsersUser from './adminUsersUser';
import Helmet from 'react-helmet';

const AdminUsers = ({ setLoading, setError, match }) => {
  const { formatMessage } = useIntl();

  return (
    <div>
      <Helmet>
        <title>{formatMessage({ id: 'admin.users.title' })}</title>
      </Helmet>

      <h3>
        <FormattedMessage id={'admin.users.title'} />
      </h3>

      <>
        <Route
          exact
          path={`${match.path}`}
          render={(props) => <AdminUsersList setLoading={setLoading} setError={setError} {...props} />}
        />

        <Route
          path={`${match.path}/:userId`}
          render={(props) => <AdminUsersUser setLoading={setLoading} setError={setError} {...props} />}
        />
      </>
    </div>
  );
};

AdminUsers.propTypes = {
  setLoading: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
};

AdminUsers.defaultProps = {};

export default AdminUsers;
